import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function MapPlaceholder({
  address
}: {
  address: string;
}) {
  return <div role="img" aria-label={`Map showing the Kayko office at ${address}`} className="relative h-[180px] overflow-hidden rounded-[12px] border border-canvas-line bg-[#EFEDE9]" data-id="element-497" data-mp="2tpgdl459c3q8">
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 400 180" preserveAspectRatio="xMidYMid slice" aria-hidden="true" data-id="element-498" data-mp="2jtdb1x6hu32r">
        <rect x="24" y="18" width="88" height="54" rx="4" fill="#E4EFE2" data-id="element-499" data-mp="3hdgg11bxlikn" />
        <rect x="270" y="110" width="110" height="56" rx="4" fill="#E4EFE2" data-id="element-500" data-mp="3ch96yzo8nqyh" />
        <path d="M-10 128 C 90 118, 150 70, 260 64 S 380 40, 420 30" stroke="#FFFFFF" strokeWidth="14" fill="none" data-id="element-501" data-mp="37glkmrayfyal" />
        <path d="M150 -10 L 176 200" stroke="#FFFFFF" strokeWidth="9" fill="none" data-id="element-502" data-mp="33fi19utp7k4m" />
        <path d="M-10 40 L 420 96" stroke="#FFFFFF" strokeWidth="6" fill="none" data-id="element-503" data-mp="1w3j4fxcrpaqy" />
        <path d="M300 -10 L 250 200" stroke="#FFFFFF" strokeWidth="6" fill="none" data-id="element-504" data-mp="1s0mpcgmfrwrr" />
        <path d="M60 200 L 110 90" stroke="#FFFFFF" strokeWidth="5" fill="none" data-id="element-505" data-mp="189q6bfsrclya" />
      </svg>
      <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-full flex-col items-center" data-id="element-506" data-mp="1d8b65e43l3m7">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand text-white shadow-[0_8px_20px_-6px_rgba(28,140,222,0.6)]" data-id="element-507" data-mp="z9bj2aw8gws5">
          <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-508" data-mp="138kcfend2sn6" />
        </span>
      </div>
      <p className="absolute bottom-3 left-3 rounded-[7px] bg-white px-2.5 py-1.5 text-[12px] font-medium text-ink shadow-[0_2px_8px_rgba(11,11,11,0.08)]" data-id="element-509" data-mp="phe6azpktwrb">
        Kayko · {address}
      </p>
    </div>;
}